import React, { Component } from 'react';


class DemoSidebar extends Component {
    render() {
        return (
            <div style={{ width: 160, height: '100%', backgroundColor: '#23282d'  }}>
                <ul style={{ paddingLeft: 5 }}>
                    {new Array(40).fill(null).map((x, i) => <li style={{ color: 'white', marginBottom: 5, listStyleType: 'none' }}>Menu item #{i}</li>)}
                </ul>
            </div>
            
        );
    }
}

export default DemoSidebar;
